import React, { useEffect, useState }  from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {matchSorter} from "match-sorter";
import { header_exp_config, aggr_keys, exp_search_delayed } from "../components/headers_config";
import {GPAP_Button_light} from "../../../../gpap-lib/Button_Collection";
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import { ReactTableServerSide } from '../../ReactTableServerSide';
import ViewError from '../components/ViewError';
import OwnerLogo from '../components/OwnerLogo'
import ActionsGrid from './components/ActionsGrid'
import { experiments_view } from '../../../service/apis';
import "../../components/custom_material_ui_like.css"
import auth from '../../../service/Auth';

import "./experiment-view.css";
import CustomizeColumns from "../components/CustomizeColumns";
import settings from '../../../DataManagementConfig';



const config = window.config;

const ExperimentView = () => {

    const [headers, setHeaders] = useState(header_exp_config);
    const [experiments, setExperiments] = useState([]);
    const [actions, setActions] = useState([]);
    const [actionSelected, setActionSelected] = useState('unselected');
    const [pagination, setPagination] = useState({});
    const [selected, setSelected] = useState({});
    const [selectedFields, setSelectedFields ] = useState({});
    const [selectAll, setSelectAll ] = useState(0);
    const [errors, setErrors ] = useState("");
    const [aggregations, setAggregations ] = useState([]);
    const [tableColumns, setTableColumns ] = useState([]);
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([]);
    const [loadData, setLoadData] = useState(true);
    
    
    useEffect(() => {
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else {
            //Update actions
            const shareAllRdConnect = 'Share with all '+ config.platform_label + ' (modify embargo to "true")';
            setActions([
                { value: 'unselected', name: '----' },
                { value: 'deleteExperiment', name: 'Delete Experiment Submission Open' },
                { value: 'closeFileSubmission', name: 'Close File Submission' },
                { value: 'shareWithGroups', name: 'Share with groups' },
                { value: 'unShareWithGroups', name: 'Unshare with groups' },
                { value: 'shareWithProject', name: 'Share with project' },
                { value: 'unShareWithProject', name: 'Unshare with project' },
                { value: 'shareWithAllRdConnect', name: shareAllRdConnect }
            ]);
            //Initialize Pagination 
            setPagination({
                page: 0, pages: 0, pageSize: 100,
                totalItems: 0,
                fields: [], filtered: [], sorted: []
            });
        }
    },[])
    
    
    const toggleRow = (experimentID) => {
        // Checkbox handler click
        let newSelectedFields = selectedFields;
        for (let experiment of experiments) {
            if (experiment.ExperimentID === experimentID && !selected[experimentID]){
                newSelectedFields[experimentID] = {
                    LocalExperimentID: experiment.LocalExperimentID,
                    sharedGroups: experiment.SharedGroups, 
                    projects: experiment.project,
                    postembargo: experiment.POSTEMBARGO,
                    file_submission_close: experiment.file_submission_close
                };
            }
            else if (experiment.ExperimentID === experimentID && selected[experimentID]){
                delete newSelectedFields[experimentID];
            }
        }
        // Update select variables
        let newSelected = Object.assign({}, selected);
        newSelected[experimentID] = !selected[experimentID];
        setSelected(newSelected);
        setSelectedFields(newSelectedFields)
        setSelectAll(2);
    }
    
    const updateColumns = (columns) => {
        let stateHeaders = [];
        for (let field of columns) {
            stateHeaders.push(header_exp_config.find(item => item.key === field));
        } 
        // Check Experiment Id existance
        if (stateHeaders.findIndex(item => item.key === "ExperimentID") === -1) {
            stateHeaders.push(header_exp_config.find(item => item.key === "ExperimentID"));
        }
        setTableColumns(columns);
        setHeaders(stateHeaders);
    }
    
    const toggleSelectAll = () => {
        // Handler Father Checkbox
        let newSelected = {};
        let newSelectedFields = {};
        if(selectAll === 0) {
            for (let experiment of experiments) {
                newSelected[experiment.ExperimentID] = true;
                newSelectedFields[experiment.ExperimentID] = {
                    sharedGroups: experiment.SharedGroups, 
                    projects: experiment.project, 
                    postembargo: experiment.POSTEMBARGO,
                    file_submission_close: experiment.file_submission_close
                };
            } 
        }
        // Update states
        setSelected(newSelected);
        setSelectedFields(newSelectedFields);
        setSelectAll(selectAll === 0 ? 1 : 0);
    }
    
    const getBooleanOptions = (headerAccessor) => {
        // Get Header Boolean Values
        let choices = [["","all"]];
        if (headerAccessor === 'file_submission_close') {
            choices.push(["true","closed"]);
            choices.push(["false","open"]);
        } else {
            choices.push(["true","true"]);
            choices.push(["false","false"]);
        }
        return choices.map(item =>{ return <option value={item[0]}> {item[1]}</option>} );
    };
    
    const getTableHeaders = () => {
        // Get Table Columns
        let columns = [];
        // Add Checkbox
        let columnCheckbox = {
            id: "checkbox",
            accessor: "IsUserOwner",
            Cell: ({ original }) => {
                //Just add checkbox if the user logged is the owner of the experiment
                if (original.IsUserOwner)
                {
                    return (
                        <input type="checkbox" className="checkbox"
                                checked={selected[original.ExperimentID.props.children]}
                                onChange={() => toggleRow(original.ExperimentID.props.children)}
                        />
                    );
                }
                else {
                    return null;
                }
            },
            Header: x => {
                    return (
                        <input type="checkbox" className="checkbox"
                            checked={selectAll === 1}
                            ref={input => {
                                if (input) {
                                    input.indeterminate = selectAll === 2;
                                }
                            }}
                            onChange={() => toggleSelectAll()}
                        />
                    );
            },
            sortable: false,
            filterable: false,
                width: 40
        };
        columns.push(columnCheckbox);
 
        //Add Headers Titles
        //Boolean Values
        let booleanKeyHeaders = ['file_submission_close','POSTEMBARGO','processed','in_platform'];
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"/></span>;
            }
            else{
                column["Header"] = header.label;
            }
            column["accessor"] = header.key;
            column["width"] = header.width;
            //Boolean Filters
            if (booleanKeyHeaders.includes(header.key)){
                column["Filter"] = ({ filter, onChange }) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : "all"}
                    >
                        {getBooleanOptions(header.key)}
                    </select>;
                column["filterMethod"] = (filter, rows) => matchSorter(rows, filter.value, { keys: ["index"] });
                column["filterAll"] = true;
            }
            else if(aggr_keys.includes(header.key))
            {
                let values = aggregations[header.key];
                let aggregates = (values !== undefined && values !== null ) ? Object.keys(values[0]) : [];
                column["Filter"] = ({ filter, onChange }) => <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : "all"}
                    >
                    <option value="">Show All</option>
                        {aggregates.sort().map(function(opt){
                            return <option value={opt}>{opt}</option>
                        })}
                    </select>;
                column["filter"] = 'equal';
            }
            columns.push(column);
        }
        // Remove not needed columns
        if (tableColumns.length !== 0) {
            let filterColumns = ["IsUserOwner", ...tableColumns];
            setHeadersTable(columns.filter(s => filterColumns.includes(s.accessor)));
        } else {
            setHeadersTable(columns);
        }
    }
    
    const getOwnerLogo = (isOwner, owner) => {
        if (isOwner) {
            return <OwnerLogo owner={owner} title={"You are the experiment owner"} />;
        } else {
            return owner;
        }
    }
    
    const getTrueFalseIcon = (isBoolean) => {
        if (isBoolean) {
            return <CheckCircleIcon color='success'/>
        }
        return <DisabledByDefaultIcon color="error"/>
    }
    
    const getDataTable = () => {
        //Build data to render on react-table
        let data = [];
        for (let experiment of experiments){
            let row = {};
            //1. Loop Headers
            for (let column of headersTable){
                if (typeof experiment[column.accessor] === "boolean"){
                    if (column.accessor === "file_submission_close") {
                        row[column.accessor] = (experiment[column.accessor])? "closed" : "open";
                    } else {
                        row[column.accessor] = getTrueFalseIcon(experiment[column.accessor]);
                    }
                }
                else if (column.accessor === "Owner") {
                    row[column.accessor] = getOwnerLogo(experiment["IsUserOwner"],experiment[column.accessor]);
                }
                else if(column.accessor === "ExperimentID"){
                    row[column.accessor] = <a href={window.location.origin + "/datamanagement/#/experimentinfo/"+ experiment[column.accessor] } target={"_blank"}>{experiment[column.accessor]}</a>
                }
                else if(column.accessor === "Participant_ID"){
                    row[column.accessor] = <a href={window.location.origin + "/phenostore/#/summary/"+ experiment[column.accessor] } target={"_blank"}>{experiment[column.accessor]}</a>
                }
                else if(column.accessor === "project"){
                    row[column.accessor] = experiment[column.accessor].split(" ").map(el =>  <a style={{paddingRight: "5px"}} href={window.location.origin + "/datamanagement/#/project/"+ el } target={"_blank"}>{el}</a>)
                }
                else {
                    row[column.accessor] = experiment[column.accessor];
                }
            }
            //2. Add IsUserOwner key
            row["IsUserOwner"] = experiment["IsUserOwner"];
            //3. Add row to data
            data.push(row);
        }
        //Update data
        setRowsTable(data);
    }
    
    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[experiments,aggregations,tableColumns,selected])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])
    
    const handleSelectChange = (event) => {
        // Handler Action Select click
        setActionSelected(event.target.value);
    }

    const getActionSelect = () => {
        return(
            <ActionsGrid actions={actions}
                         actionSelected={actionSelected} 
                         to={{pathname:'/actionpage',action: actionSelected,actions: actions,
                              experiments: selectedFields, next:'/experiments'}}
                         experimentsSelected={Object.keys(selectedFields).length}
                         handleSelectChange={handleSelectChange}
            />
        );
    }
    
    const closeModal = () => {
        setErrors("");
    }
    
    const loadTableData = (state,instance) => {
        // Method to call API Endpoint to get React Table Data
        let fields = [];
        setLoadData(true);
        // Get fields to be requiered
        for (let header of headers) {
            fields.push(header.key);
        }
        fields.push("IsUserOwner");
        // Call API Endpoint 
        let data_query = {
            "page" : (state.page + 1),
            "pageSize" : state.pageSize,
            "fields" : fields
        };
        // Check filtered Criteria 
        if (state.filtered) {
            data_query["filtered"] = state.filtered.map( item => ( { id:item.id, value:[item.value]} ) );
        }
        // Check sorted Criteria 
        if (state.sorted) {
            data_query["sorted"] = state.sorted;
        }
        // Check Aggregations if needed 
        if ( aggregations.length === 0) {
            data_query["aggregates"] = aggr_keys;
        }
        // Call POST Data
        experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            if (aggregations.length == 0) {
                setExperiments(data["items"]);
                setAggregations(data._meta.aggregates);
                setPagination({
                    page : data["_meta"]["page"],
                    pages : data["_meta"]["total_pages"],
                    pageSize : data["_meta"]["page_size"],
                    totalItems : data["_meta"]["total_items"],
                    fields :fields, filtered : state.filtered,
                    sorted : state.sorted
                });
                setLoadData(false);
            } else {
                setExperiments(data["items"]);
                setPagination({
                    page : data["_meta"]["page"],
                    pages : data["_meta"]["total_pages"],
                    pageSize : data["_meta"]["page_size"],
                    totalItems : data["_meta"]["total_items"],
                    fields :fields, filtered : state.filtered,
                    sorted : state.sorted
                });
                setLoadData(false); 
            }  
        })
    }
    
    const getCsvData = async (event) => {
        // Trigger Load Process
        setLoadData(true);
        // Get All Data to be printed to CSV Files
        let data_query = {
            "page" : 1,
            "pageSize" : settings.apiExperimentCSVPageSize,
            "fields" : [...pagination.fields,"SubmitterID_no_space"],
            "filtered" : pagination.filtered.map( item => ( { id:item.id, value:[item.value]} ) ),
            "sorted": pagination.sorted
        };
        let getData = true;
        let allItems = [];
        // Get All Data
        while (getData){
              // Call POST Data
              await experiments_view(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
              .then((response) => {
                  return response.json()
              })
              .then((data) => {
                  allItems.push(...data["items"]);
                  if (data_query.page < data["_meta"]["total_pages"]){
                        getData = true;
                        data_query.page = data_query.page + 1;
                  }
                  else getData = false;
              })
        }
        // Build data for CSV
        let data = [];
        allItems.forEach( item => {
            let row = {};
            //1. Loop Headers
            for (let header of headers){
                if (typeof item[header.key] === "boolean") row[header.key] = item[header.key].toString();
                else row[header.key] = item[header.key];
            }
            row["SubmitterID_no_space"] = item["SubmitterID_no_space"];
            //2. Add row to data
            data.push(row);
        });
        // Trigger Download CSV
        let csvHeader =  [...headers, { label: 'Submitter ID No Spaces', key: 'SubmitterID_no_space'}];
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(data,csvHeader,`${today}_experiment_list.csv`);
        setLoadData(false);
    }
    
    if (errors !== "") {
        // Show popup in case an error with the loggin occurs 
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                <Typography variant={"h5"} align={"center"}> List of Experiments </Typography>

                <Box p={2}>
                    <Box p={1} style={{float:"left"}}>
                        <GPAP_Button_light href = "#/management"  startIcon={<ArrowBackIcon />}>Back</GPAP_Button_light>
                    </Box>
                    <Box p={0} style={{float:"left"}}>
                        <CustomizeColumns
                            type = {"exp"}
                            updateColumns = {updateColumns}
                        />
                        <CsvButton getCsvData={getCsvData} />
                    </Box>
                    {getActionSelect()}
                </Box >
                <Box p={2} className={"info"}>
                    <Typography variant={"subtitle1"}>Click on an Experiment ID to see the details of the experiment</Typography>
                </Box>

                <ReactTableServerSide
                    headers={headers}
                    columns={headersTable}
                    data={rowsTable}
                    pagination={pagination}
                    loadTableData={loadTableData}
                    loading={loadData}
                    fieldsDelay={exp_search_delayed}
                />
            </div>
        );
    }
}

export default ExperimentView;